/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable promise/catch-or-return */

import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import { userInfoSync } from 'hub-http/userInfo';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { SidebarPage } from 'foundations-components/transitional/components/SidebarPage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import Config from './api/Config';
import { navConfigSettingsV4Key, navConfigSettingsPreferencesKey } from './utils/storageSettings';
import NavGroup from './components/NavGroup';
import SideNav from './components/SideNav';
import ReturnLinkHelper from './utils/ReturnLinkHelper';
import BackLink from './components/BackLink';
import once from 'settings-ui-nav/utils/once';
import findNavItem from 'settings-ui-nav/utils/findNavItem';
import { convertToTrackingUrl } from 'settings-ui-nav/utils/convertToTrackingUrl';
import NavItem from './utils/NavItem';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { SearchButton } from './components/SearchButton';
import { GATES } from './constants/Auth';
import { LegacySearchButton } from './components/LegacySearchButton';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEV_PORTAL_ACCESS_SCOPE = 'developer-portal-access';
const FULL_CRM_ACCESS_SCOPE = 'full-crm-access';
const trackPageView = once((track, trackingOptions) => {
  if (typeof track === 'function') {
    track('settingsNavPageView', trackingOptions);
  }
});
class SettingsPage extends Component {
  constructor(props) {
    super(props);
    this.useUpdatedSearchButton = false;
    const {
      user,
      gates
    } = userInfoSync();
    const userScopes = user.scopes;
    const isDevPortal = userScopes.includes(DEV_PORTAL_ACCESS_SCOPE) && !userScopes.includes(FULL_CRM_ACCESS_SCOPE);
    this.state = {
      config: Config.getLocal(navConfigSettingsV4Key) || [],
      settingsPreferences: Config.getLocal(navConfigSettingsPreferencesKey) || [],
      isDevPortal
    };
    ReturnLinkHelper.hydrate();
    this.handleBackLinkClick = this.handleBackLinkClick.bind(this);
    this.useUpdatedSearchButton = gates.includes(GATES.GLOBAL_SEARCH);
  }
  componentDidMount() {
    Promise.all([Config.get(navConfigSettingsV4Key), Config.get(navConfigSettingsPreferencesKey)]).then(([config, settingsPreferences]) => {
      if (!config || !settingsPreferences) {
        return;
      }
      this.setState({
        config,
        settingsPreferences
      }, this.trackPageView);
    });
  }
  trackPageView() {
    if (this.props.disablePageViewTracking) {
      return;
    }
    const {
      track,
      settingsApp,
      pathname,
      subNavigation
    } = this.props;
    const {
      config,
      settingsPreferences
    } = this.state;
    const currentNavItem = findNavItem(pathname, [config, settingsPreferences]);
    if (!currentNavItem) {
      return;
    }
    const screen = currentNavItem && currentNavItem.settingsGroup;
    const subscreen = currentNavItem && currentNavItem.trackingScreen;
    trackPageView(track, {
      settingsApp,
      screen,
      subscreen,
      subscreen2: subNavigation
    });
  }
  handleBackLinkClick(targetHref) {
    if (!this.state.loadedConfig) {
      return;
    }
    const {
      track,
      settingsApp,
      pathname
    } = this.props;
    const {
      config,
      settingsPreferences
    } = this.state;
    const currentNavItem = findNavItem(pathname, [config, settingsPreferences]);
    if (!currentNavItem) {
      return;
    }
    const screen = currentNavItem && currentNavItem.settingsGroup;
    const subscreen = currentNavItem && currentNavItem.trackingScreen;
    const santizedHref = convertToTrackingUrl(targetHref || undefined);
    if (typeof track === 'function') {
      track('settingsNavBackLink', {
        settingsApp,
        screen,
        subscreen,
        backLocation: santizedHref
      });
    }
  }
  renderMediaRight({
    children
  }) {
    return /*#__PURE__*/_jsx(View, {
      order: 2,
      children: children
    });
  }
  renderSideNav() {
    const {
      config,
      settingsPreferences,
      isDevPortal
    } = this.state;
    const {
      pathname,
      settingsApp,
      onClickHandler,
      track,
      hasStagedChanges
    } = this.props;
    const preferencesIsFirstGroup = settingsPreferences.length > 0;
    const StyledDiv = styled.div.withConfig({
      displayName: "SettingsPage__StyledDiv",
      componentId: "y9vu9z-0"
    })(["&&{hr:first-of-type{display:none;}}"]);
    if (config === undefined || settingsPreferences === undefined) {
      return /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.loading-error.title"
        }),
        type: "danger",
        children: /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "settings-ui-nav.loading-error.description"
          })
        })
      });
    }
    let preferencesNavItem;
    if (settingsPreferences.length) {
      preferencesNavItem = new NavItem(null, {
        id: 'settings-preferences',
        label: I18n.text('settings-ui-nav.your-preferences'),
        children: settingsPreferences
      });
    }
    const header = /*#__PURE__*/_jsx(MediaObject, {
      itemRight: this.useUpdatedSearchButton ? /*#__PURE__*/_jsx(SearchButton, {}) : /*#__PURE__*/_jsx(LegacySearchButton, {}),
      MediaRight: this.renderMediaRight,
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        "aria-level": 1,
        marginBlockEnd: "1100",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "settings-ui-nav.page-title"
        })
      })
    });
    return /*#__PURE__*/_jsxs(StyledDiv, {
      children: [/*#__PURE__*/_jsx(BackLink, {
        onClick: this.handleBackLinkClick,
        isDevPortal: isDevPortal
      }), header, settingsPreferences && settingsPreferences.length ? /*#__PURE__*/_jsx(NavGroup, {
        config: preferencesNavItem,
        onItemClick: onClickHandler,
        pathname: pathname,
        settingsApp: settingsApp,
        track: track,
        hasStagedChanges: hasStagedChanges,
        isFirstGroup: preferencesIsFirstGroup
      }) : null, /*#__PURE__*/_jsx(SideNav, {
        config: config,
        onItemClick: onClickHandler,
        pathname: pathname,
        settingsApp: settingsApp,
        track: track,
        hasStagedChanges: hasStagedChanges,
        hasFirstGroup: !preferencesIsFirstGroup
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(SidebarPage, {
        "data-reagan-test": "settings-page",
        sidebarComponent: this.renderSideNav(),
        children: this.props.children
      })
    });
  }
}
SettingsPage.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * The current pathname, either window.location.pathname or
   * with react-router-redux: state.routing.locationBeforeTransitions.basename
   *  + state.routing.locationBeforeTransitions.pathname;
   */
  pathname: PropTypes.string.isRequired,
  /**
   * Optional handler for link clicks. Gets passed the event and the NavItem that
   * is clicked. The handler provided should, in most cases, match links by href
   * to implement custom routing for internal links and let external link clicks
   * propagate normally.
   */
  onClickHandler: PropTypes.func,
  /**
   * The name of the application that the nav is being used in. This will be attached
   * to usage tracking events to make it easier to distinguish events created by
   * indepedent settings deployables
   */
  settingsApp: PropTypes.string,
  /**
   * The name of the currently view subnavigation. This will be attached
   * to usage tracking events to see which subnavigation is viewed within a page.
   */
  subNavigation: PropTypes.string,
  /**
   * A track function that gets called with
   * events from settings-ui-nav/events.yaml
   */
  track: PropTypes.func.isRequired,
  /**
   * True to disable pageView tracking.
   */
  disablePageViewTracking: PropTypes.bool
};
SettingsPage.defaultProps = {
  /**
   * We want to handle pageView unless specified otherwise.
   */
  disablePageViewTracking: false
};
export default SettingsPage;